export enum PosterEditingNavbarMode {
  DEFAULT = 'DEFAULT',
  REGEN = 'REGEN',
  EMBEDDED = 'EMBEDDED',
}
